import React from 'react';
import { motion } from 'framer-motion';

const Education = () => {
  return (
    <section id="education" className="bg-black grainy py-24 sm:py-32 px-4">
      <div className="max-w-3xl mx-auto">
        <motion.h2
          className="text-4xl md:text-5xl font-bold text-text-primary text-center mb-12 font-heading"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          Academic Dossier
        </motion.h2>

        {/* The Paper Container */}
        <motion.div
          className="bg-[#111111] p-8 sm:p-12 rounded-lg border border-white/10"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: 'easeOut', delay: 0.2 }}
        >
          {/* --- Header --- */}
          <h3 className="text-center font-serif text-3xl sm:text-4xl font-bold text-text-primary">
            A Record of Academic Qualifications
          </h3>
          <p className="text-center mt-4 text-text-secondary">Dheeraj Reddy</p>
          <p className="text-center text-sm text-text-secondary">Sathyabama Institute of Science and Technology, Chennai</p>
          <hr className="my-8 border-white/10" />

          {/* --- Abstract & Keywords --- */}
          <div className="space-y-6">
            <div>
              <h4 className="font-bold text-text-primary mb-2">Abstract</h4>
              <p className="italic text-text-secondary">
                This document outlines the academic history of Dheeraj Reddy, providing a chronological record of formal education. It covers tertiary education in Computer Science and foundational secondary education, highlighting key achievements and areas of focus.
              </p>
            </div>
            <div>
              <h4 className="font-bold text-text-primary mb-2">Keywords</h4>
              <p className="font-mono text-sm text-accent">
                Computer Science, Full Stack Development, Artificial Intelligence, Machine Learning, Data Structures, Algorithms
              </p>
            </div>
          </div>

          {/* --- Main Body --- */}
          <div className="mt-10 space-y-8">
            <div>
              <h4 className="font-serif font-bold text-xl text-text-primary">1. Tertiary Education</h4>
              <div className="mt-2 pl-4 border-l-2 border-white/10">
                <p className="font-bold text-text-primary mt-2">Bachelor of Engineering, Computer Science</p>
                <p className="text-text-secondary">Sathyabama Institute of Science and Technology, Chennai (2021 - 2025)</p>
                <ul className="list-disc list-inside mt-2 text-text-secondary space-y-1">
                  <li>Specialized in Artificial Intelligence and Machine Learning.</li>
                  <li>Final Year Project: Developed a Machine Learning Based Firewall. <strong><a href='https://ieeexplore.ieee.org/document/11013563' target='_blank' rel='noreferrer'>(Read Paper)</a></strong></li>
                </ul>
              </div>
            </div>
            <div>
              <h4 className="font-serif font-bold text-xl text-text-primary">2. Secondary Education</h4>
              <div className="mt-2 pl-4 border-l-2 border-white/10">
                 <p className="font-bold text-text-primary mt-2">All India Senior School Certificate Examination</p>
                 <p className="text-text-secondary">Bhashyam Blooms, Maheshwaram (2018 - 2019)</p>
                 <ul className="list-disc list-inside mt-2 text-text-secondary space-y-1">
                   <li>Achieved a score of 90% in the board exams.</li>
                 </ul>
              </div>
            </div>
          </div>

        </motion.div>
      </div>
    </section>
  );
};

export default Education;